// extracted by mini-css-extract-plugin
export default {"skeleton":"Skeleton_skeleton__zVAmE","pulse":"Skeleton_pulse__YXTwj","pulse1":"Skeleton_pulse1__-SLy7"};